import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpBackend from 'i18next-http-backend';

i18n.use(HttpBackend).use(initReactI18next);

if (!i18n.isInitialized) {
  i18n.init({
    ns: ['common', 'auth'],
    defaultNS: 'common',
    lng: 'en',
    fallbackLng: 'en',
    supportedLngs: ['en'],
    debug: import.meta.env.DEV,
    interpolation: {
      escapeValue: false,
    },
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
    },
  });
}

export default i18n;
